import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PASSWORD_RULES, PASSWORD_MAX_LENGTH } from '../constants/password-rules.constants';

export function passwordComplexityValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) return null;

    const errors: ValidationErrors = {};

    for (const rule of PASSWORD_RULES) {
      if (!rule.pattern.test(value)) {
        errors[rule.key] = true;
      }
    }

    if (value.length > PASSWORD_MAX_LENGTH) {
      errors['maxLength'] = true;
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };
}
